var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossworld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 104,
    viewBox: "0 0 103 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9481 0H16C7.16344 0 0 7.16344 0 16V87.1562C0 95.9928 7.16346 103.156 16 103.156H86.9481C95.7846 103.156 102.948 95.9928 102.948 87.1562V16C102.948 7.16344 95.7846 0 86.9481 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6117 6.40234H15.9855C10.4627 6.40234 5.98553 10.8795 5.98553 16.4023V49.1326H48.6117V6.40234Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6117 54.8574H5.98553V87.5876C5.98553 93.1105 10.4627 97.5876 15.9855 97.5876H48.6117V54.8574Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 54.8574H54.3368V97.5876H86.9629C92.4858 97.5876 96.9629 93.1105 96.9629 87.5876V54.8574Z",
    fill: "#18E1B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4506 20.9221V34.0378L31.1237 27.8963L33.6219 30.5507L23.6811 41.2723C20.0378 37.3688 17.2793 34.3501 13.7402 30.5507L16.2384 27.8963L21.9115 34.0378V17.5391H55.5856V20.9221H25.4506Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossworld);
export default __webpack_public_path__ + "static/media/crossworld.b409081273c2282e2da5a76b220f408d.svg";
export { ForwardRef as ReactComponent };